import React from "react";
import { useLang } from "@/context/LanguageContext";
import { GMOAA } from "@/constants/testIds";

const palette = {
  gold: "from-gmoaa-gold-light to-[#f3e7bd] border-gmoaa-gold text-gmoaa-text-dark",
  green: "from-gmoaa-green-light to-[#d7e8e0] border-gmoaa-green/40 text-gmoaa-green",
  saffron: "from-gmoaa-saffron-light to-[#fde4b0] border-gmoaa-saffron/50 text-gmoaa-saffron-hover",
};

// Soft-fade advertisement slot. Gentle animation, never strobing.
export const AdSlot = ({ ad, className = "", height = "h-28" }) => {
  const { t, tf } = useLang();
  const tone = palette[ad?.color] || palette.gold;

  return (
    <div
      data-testid={GMOAA.adSlot}
      className={`ad-slot animate-ad-fade rounded-xl border bg-gradient-to-br ${tone} ${height} ${className} flex flex-col justify-center px-6 py-4 hover:shadow-md`}
    >
      <span className="absolute right-3 top-2 rounded-full bg-black/10 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider">
        {t("advertisement")}
      </span>
      <p className="font-serif text-lg font-semibold leading-tight">{tf(ad, "title")}</p>
      {tf(ad, "subtitle") && <p className="mt-1 text-sm opacity-80">{tf(ad, "subtitle")}</p>}
    </div>
  );
};
